<template>
  <el-container style="height: 100%;background-color: #ffffff">
    <el-aside width="260px">
      <model @deviceModelChoose="deviceModelChoose" @deviceModelDelete="deviceModelId = null" />
    </el-aside>
    <el-main style="padding: 0 10px;">
      <list v-if="deviceTypeId !== null && deviceModelId !== null" :deviceTypeId ="deviceTypeId" :deviceModelId="deviceModelId" />
    </el-main>
  </el-container>
</template>

<script>
import model from './model/model.vue'
import list from './param/list.vue'

export default {
  name: '',
  data () {
    return {
      deviceTypeId: null,
      deviceModelId: null
    }
  },

  components: {
    model,
    list
  },

  mounted () {},

  methods: {
    deviceModelChoose (obj) {
      this.deviceTypeId = obj.deviceTypeId
      this.deviceModelId = obj.deviceModelId
    }
  }
}
</script>
